export default __webpack_public_path__ + "static/media/club.a7650f6d.svg";